import http from "@/http/aisea/axios_v2";
const resource = "/enterprises/manning/vessels";
import qs from "qs";

/**
 * (V2)配乗船舶API
 *
 */
export default {
  /**
   * 配乗船舶の一覧を取得します。
   *
   * @param {Object} params - 以下のいずれかの条件を指定して絞り込みが可能です。
   * details:
   *   - MANNING_VESSEL_ROLE
   *   - MANNING_VESSEL_ROLE_POSITION
   */
  fetch(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  /**
   * 配乗可能な船舶の一覧を取得します。
   * @param {*} params
   * @param {Object} params - 以下のいずれかの条件を指定して絞り込みが可能です。
   * @param {Array} params.details - 詳細情報の絞り込み条件
   *  - MANNING_VESSEL_ROLE
   *  - MANNING_VESSEL_ROLE_POSITION
   * @param {String} params.date_at - 日付の絞り込み条件
   * - YYYY-MM-DD形式で指定
   * @param {String} params.enterprise_crew_id - クルーID
   * @returns
   */
  fetchAssignable(params) {
    return http.get(`${resource}/assignable`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
};
